"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _AssignmentTurnedIn = _interopRequireDefault(require("@material-ui/icons/AssignmentTurnedIn"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TicketCardList = function TicketCardList(_ref) {
  var tickets = _ref.tickets,
      openTicket = _ref.openTicket,
      _ref$emptyLabel = _ref.emptyLabel,
      emptyLabel = _ref$emptyLabel === void 0 ? 'Geen aanvragen.' : _ref$emptyLabel;

  if (!tickets || tickets.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      Icon: _Edit["default"],
      label: emptyLabel
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_solarReact.CardList, {
    items: R.sortBy(R.prop('createdAt'))(tickets)
  }, function (_ref2) {
    var _id = _ref2._id,
        author = _ref2.author,
        actor = _ref2.actor,
        product = _ref2.product,
        status = _ref2.status,
        statusLabel = _ref2.statusLabel,
        unitName = _ref2.unitName,
        unitKey = _ref2.unitKey;
    // const c = certification().certificate();
    // const a = author();
    return /*#__PURE__*/_react["default"].createElement(_ui.ContactCard, {
      key: _id,
      avatarUrl: author.person.avatar && author.person.avatar.src,
      fullName: author.person.fullName,
      email: author.email,
      subheader: "".concat(unitKey, ". ").concat(unitName),
      onClick: function onClick() {
        return openTicket(_id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_AssignmentTurnedIn["default"], null),
      text: product.renderTitle,
      textLabel: product.renderCodes
    }), /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: actor.person.avatar && actor.person.avatar.src
      }),
      text: actor.person.fullName,
      textLabel: statusLabel
    })));
  });
};

TicketCardList.propTypes = {
  className: _propTypes["default"].string,
  tickets: _propTypes["default"].array
};
TicketCardList.defaultProps = {
  className: '',
  tickets: []
};
var _default = TicketCardList;
exports["default"] = _default;